import React from 'react'
import { aisProps } from './ais-interface'
import { Skeleton } from 'antd'

const Ais = ({ img, isBigger, aiClick, aiDetails, loading, showVerified, name, active }: aisProps) => {
	return (
		loading ?
			<div>
				<Skeleton.Button active={true} size={'large'} shape={'square'} block={true}
					style={{
						height: '7rem',
						marginBottom: '0.3rem',
						borderRadius: '29px',
						marginRight: '1rem'
					}}
				/>
			</div>
			:
			<div className='mr-4'>
				<div
					className={`${active ? 'border-[2px] border-appcolorpurple rounded-[29px]' : ''} p-[0.3rem]`}
				>
					<img
						src={img}
						alt={aiDetails.name}
						className='rounded-[29px] h-[5.9rem] object-cover cursor-pointer'
						onClick={() => {
							if (aiDetails !== undefined && aiClick !== undefined) {
								aiClick(aiDetails)
							}
						}}
					/>
				</div>

				{
					name !== undefined ?
						<p className={`mt-[0.3rem] font-semibold text-appcolorblack text-base capitalize text-center ${active ? '' : 'opacity-[0.6]'}`}>
							{name}
						</p> : null
				}
			</div>
	)
}

Ais.defaultProps = {
	showVerified: false,
	active: false
}

export default Ais